import { useEffect } from "react";
import { useCookieConsent } from "react-cookie-manager";

/**
 * Bridges custom UI elements (like our settings link) with the CookieManager provider.
 * Listens for the shared `cookiekit:open-preferences` event and routes it to the
 * library's preferences modal.
 */
export function CookieConsent(): null {
  const { openPreferencesModal } = useCookieConsent();

  useEffect(() => {
    const handler = () => {
      openPreferencesModal();
    };

    window.addEventListener("cookiekit:open-preferences", handler);
    return () => {
      window.removeEventListener("cookiekit:open-preferences", handler);
    };
  }, [openPreferencesModal]);

  return null;
}

export default CookieConsent;
